module.exports = __webpack_public_path__ + "img/communication-studies-a.7268b665.jpg";